<template>
  <el-row>
    <el-col :span="24">
      <div v-if="refund.transactions && refund.transactions.length">
        <h4 v-for="transaction in refund.transactions">
          <strong class="text-success">
            {{transaction.amount | currency}} {{transaction.currency}}
          </strong>
          <template v-if="transaction.gateway">
            has been refunded on
            <strong class="text-success">
              {{transaction.gateway | underscoresToSpaces | capitalize}}
            </strong>
          </template>
          <template v-else>
            has been adjusted
          </template>
          for order <strong class="text-success">{{transaction.order_id}}</strong>.
          ({{transaction.processed_at}})
        </h4>
      </div>
      <div v-else>
        <h4>
          <strong class="text-success">
            {{refund.amount | currency}}
          </strong>
          <template v-if="refund.type = 'adjustment'">
            has been adjusted
          </template>
          <template v-else>
            has been refunded
          </template>
          at ({{refund.created_at}})
        </h4>
      </div>
    </el-col>
  </el-row>
</template>

<script>
  import {
    currency,
    underscoresToSpaces,
    capitalize,
  } from '../../../filters';

  export default {
    name: 'OrderRefundTransactions',
    props: {
      refund: {
        type: Object,
        required: true,
      },
    },
    filters: {
      currency,
      underscoresToSpaces,
      capitalize,
    },
  };
</script>
